import React, { Component } from "react";
// react components
import { connect } from 'react-redux'
// @material-ui/core components
import { Paper } from '@material-ui/core';
import CompanyProfileForm from '../DashComponents/UserProfilePage/CompanyProfileForm'
import CompanyProfileStyle from '../DashComponents/UserProfilePage/CompanyStyle'



class UserProfile extends Component {
  constructor(props){
    super(props);
    this.state = {
      profile: ''
    }
  }
  handleColorChange =(e) =>{
    //console.log('USER PROFILE COLOR CHANGE')
    this.props.handleColorChange()
  }
  handleLogoChange =(e) =>{
    //console.log('UserProfile - handleLogoChange')
    this.props.handleLogoChange()
  }
  componentDidMount(){
    this.setState({
      profile: this.props.profile
    })
    this.props.handleColorChange()
    this.props.handleLogoChange()
  }
  render() {
    //console.log('USER PROFILE STATE', this.state)
   // console.log('USER PROFILE', this.props)
      return (
          <div className="slideUp">
             
             <Paper style ={{ marginTop: '24px', padding: '24px' }}>
                <CompanyProfileForm  />
              </Paper>
              <Paper style ={{ marginTop: '24px', padding: '24px' }}>
                <CompanyProfileStyle  profile={this.props.profile} handleColorChange={this.handleColorChange} handleLogoChange={this.handleLogoChange}/>
              </Paper>
          </div>
      )
  }

}


const mapStateToProps = (state)=> {
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile  
  };
};

export default connect(mapStateToProps, null )(UserProfile)